import { render, staticRenderFns } from "./Logbook.vue?vue&type=template&id=1b6d27d2&"
import script from "./Logbook.vue?vue&type=script&lang=js&"
export * from "./Logbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports